import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__ from "../../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__badge_mjs_d75bef04__ from "../badge.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__separator_mjs_58b8de16__ from "../separator.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__tooltip_mjs_fef5306d__ from "../tooltip.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__ from "./utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__ from "./pricing-context.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__ from "../../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__ from "../dialog.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const planVariantStyles = {
    primary: {
        className: "bg-[rgba(116,255,241,0.1)] text-brand-primary shadow-xs hover:bg-[rgba(116,255,241,0.15)] border border-brand-primary/20",
        color: "#74FFF1"
    },
    secondary: {
        className: "bg-[rgba(102,196,248,0.1)] text-[rgba(102,196,248,1)] shadow-xs hover:bg-[rgba(102,196,248,0.15)] border border-[rgba(102,196,248,0.2)]",
        color: "#66C4F8"
    },
    premium: {
        className: "bg-[#FFC459] text-grayscale-darkest hover:bg-[#FFB73D]",
        color: "#FFC459"
    }
};
const highlightVariantStyles = {
    primary: {
        badgeClassName: "bg-brand-primary text-grayscale-darkest",
        ctaClassName: "bg-brand-primary text-grayscale-darkest border-none hover:bg-brand-primary/90",
        cardBorder: "border-brand-primary/50"
    },
    secondary: {
        badgeClassName: "text-foreground bg-grayscale-dark border-foreground/30",
        cardBorder: "border-foreground/20"
    }
};
const PricingCard = ({ plan, isCurrentPlan, onSelect, onManageSubscription, disabled, isLoading, planIndex = 0, allPlans = [], mergeFeatures = true, cornerClasses = "", currentPriceIds = [], isCancelled = false, isCustomPlan = false, isLegacyPlan = false })=>{
    const [showDowngradeDialog, setShowDowngradeDialog] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const [showLegacyDialog, setShowLegacyDialog] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(false);
    const accentColor = planVariantStyles[plan.variant].color;
    const highlightStyles = isCurrentPlan ? highlightVariantStyles.secondary : plan.highlight ? highlightVariantStyles[plan.highlight.variant] : null;
    const visibleFeatures = plan.features.filter((f)=>f.visible);
    const getCtaLabel = ()=>{
        if (isCurrentPlan || "enterprise" === plan.id) return plan.cta.label;
        if (currentPriceIds.length > 0) {
            const currentPlanIndex = (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.findCurrentPlanIndex)(allPlans, currentPriceIds);
            if (-1 !== currentPlanIndex) {
                if (planIndex > currentPlanIndex) return "Upgrade";
                if (planIndex < currentPlanIndex) return "Downgrade";
            }
        }
        return plan.cta.label;
    };
    const isDowngrade = ()=>{
        if (0 === currentPriceIds.length || isCurrentPlan) return false;
        const currentPlanIndex = (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.findCurrentPlanIndex)(allPlans, currentPriceIds);
        return -1 !== currentPlanIndex && planIndex < currentPlanIndex;
    };
    const getLostFeatures = ()=>{
        if (0 === currentPriceIds.length) return [];
        const currentPlanIndex = (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.findCurrentPlanIndex)(allPlans, currentPriceIds);
        if (-1 === currentPlanIndex) return [];
        const currentPlan = allPlans[currentPlanIndex];
        const targetFeatureKeys = new Set(plan.features.filter((f)=>f.visible).map((f)=>f.key));
        return currentPlan.features.filter((feature)=>feature.visible && !targetFeatureKeys.has(feature.key));
    };
    const handlePlanSelection = ()=>{
        if (isCustomPlan && !isCurrentPlan) {
            window.location.href = "mailto:support@superwall.com?subject=Custom%20Plan%20Change%20Request";
            return;
        }
        if (isLegacyPlan && !isCurrentPlan && "enterprise" !== plan.id) setShowLegacyDialog(true);
        else if (isDowngrade()) setShowDowngradeDialog(true);
        else onSelect?.(plan.id, plan.price.ids, "upgrade");
    };
    const getMergedFeatures = ()=>{
        if (!mergeFeatures || 0 === allPlans.length) return [
            {
                label: "Includes:",
                isHeader: true,
                icon: void 0
            },
            ...visibleFeatures.map((f)=>({
                    label: f.label,
                    icon: f.icon,
                    isHeader: false
                }))
        ];
        const currentPlanFullIndex = allPlans.findIndex((p)=>p.id === plan.id);
        if (currentPlanFullIndex <= 0) return [
            {
                label: "Includes:",
                isHeader: true,
                icon: void 0
            },
            ...visibleFeatures.map((f)=>({
                    label: f.label,
                    icon: f.icon,
                    isHeader: false
                }))
        ];
        const previousPlan = allPlans[currentPlanFullIndex - 1];
        const previousFeatureKeys = new Set(previousPlan.features.filter((f)=>f.visible).map((f)=>f.key));
        const newFeatures = plan.features.filter((feature)=>!previousFeatureKeys.has(feature.key) && feature.visible);
        if (0 === newFeatures.length) return [
            {
                label: "Includes:",
                isHeader: true,
                icon: void 0
            },
            ...visibleFeatures.map((f)=>({
                    label: f.label,
                    icon: f.icon,
                    isHeader: false
                }))
        ];
        return [
            {
                label: `Everything in ${previousPlan.title}, plus:`,
                isHeader: true,
                icon: void 0
            },
            ...newFeatures.map((f)=>({
                    label: f.label,
                    icon: f.icon,
                    isHeader: false
                }))
        ];
    };
    const displayFeatures = mergeFeatures ? getMergedFeatures() : [
        {
            label: "Includes:",
            isHeader: true,
            icon: void 0
        },
        ...visibleFeatures.map((f)=>({
                label: f.label,
                icon: f.icon,
                isHeader: false
            }))
    ];
    const isPrimaryHighlight = !isCurrentPlan && plan.highlight?.variant === "primary";
    const isSecondaryHighlight = isCurrentPlan || plan.highlight?.variant === "secondary";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("bg-grayscale-darker border grid grid-rows-subgrid row-span-5 gap-y-3 text-left p-4 sm:p-6 relative", isPrimaryHighlight && `rounded-2xl scale-[1.04] z-20 shadow-lg border ${highlightStyles?.cardBorder}`, isSecondaryHighlight && `rounded-xl scale-[1.015] z-10 shadow-sm border ${highlightStyles?.cardBorder}`, !isPrimaryHighlight && !isSecondaryHighlight && cornerClasses, disabled && "*:brightness-50 pointer-events-none"),
        children: [
            (plan.highlight || isCurrentPlan) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__badge_mjs_d75bef04__.Badge, {
                variant: "headless",
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("absolute -top-3 left-1/2 transform -translate-x-1/2 whitespace-nowrap", highlightStyles?.badgeClassName),
                children: isCurrentPlan ? "You're on this plan" : plan.highlight?.label
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "text-base leading-tight",
                style: {
                    color: accentColor
                },
                children: isCustomPlan ? "Custom Plan" : plan.title
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "flex items-baseline gap-1.5 flex-wrap",
                children: [
                    plan.price.amountLabel.includes("$") ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("h3", {
                        className: "text-2xl sm:text-3xl text-foreground leading-tight",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                className: "text-muted-foreground mr-0.5",
                                children: "$"
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                className: "text-foreground",
                                children: plan.price.amountLabel.replace("$", "")
                            })
                        ]
                    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h3", {
                        className: "text-2xl sm:text-3xl text-foreground leading-tight",
                        children: plan.price.amountLabel
                    }),
                    plan.price.interval && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                        className: "text-muted-foreground text-sm sm:text-base",
                        children: [
                            "/ ",
                            plan.price.interval
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                className: "text-secondary-foreground text-sm leading-relaxed",
                children: plan.price.description.tooltip ? (()=>{
                    const words = plan.price.description.label.split(" ");
                    const lastWord = words.pop();
                    const restOfText = words.join(" ");
                    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                        children: [
                            restOfText,
                            " ",
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                                className: "whitespace-nowrap",
                                children: [
                                    lastWord,
                                    " ",
                                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_fef5306d__.Tooltip, {
                                        defaultOpen: false,
                                        disableHoverableContent: true,
                                        children: [
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_fef5306d__.TooltipTrigger, {
                                                asChild: true,
                                                className: "cursor-help inline-flex items-center mt-[-2px] align-middle",
                                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                                                    className: "w-4 h-4 text-muted-foreground",
                                                    fill: "currentColor",
                                                    viewBox: "0 0 20 20",
                                                    "aria-hidden": "true",
                                                    children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z",
                                                        clipRule: "evenodd"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_fef5306d__.TooltipContent, {
                                                className: "z-[9999]",
                                                children: plan.price.description.tooltip
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                })() : plan.price.description.label
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                children: [
                    !isCurrentPlan || onManageSubscription || isCustomPlan ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                        variant: "headless",
                        onClick: ()=>{
                            if (isCurrentPlan && onManageSubscription) return void onManageSubscription(isCustomPlan);
                            if (!isCurrentPlan && "enterprise" === plan.id) return void window.open("https://superwall.com/contact/book-a-demo", "_blank");
                            if (!isCurrentPlan && !disabled) handlePlanSelection();
                        },
                        disabled: isCustomPlan ? false : disabled || isCurrentPlan && (!plan.price.ids || 0 === plan.price.ids.length) && "Contact Support" !== plan.cta.label,
                        isLoading: isLoading,
                        size: "lg",
                        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)(planVariantStyles[plan.variant].className, highlightStyles?.ctaClassName, "rounded-full w-full text-sm"),
                        children: isCurrentPlan ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                            children: [
                                isCancelled ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__.SIcon, {
                                    type: "refresh",
                                    className: "size-3.5"
                                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__.SIcon, {
                                    type: "settings",
                                    className: "size-3.5"
                                }),
                                isCancelled ? "Resubscribe" : "Manage"
                            ]
                        }) : getCtaLabel()
                    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_fef5306d__.Tooltip, {
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_fef5306d__.TooltipTrigger, {
                                className: "w-full",
                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                                    variant: "headless",
                                    disabled: true,
                                    size: "lg",
                                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)(planVariantStyles[plan.variant].className, highlightStyles?.ctaClassName, "rounded-full w-full text-sm"),
                                    children: "Current Plan"
                                })
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__tooltip_mjs_fef5306d__.TooltipContent, {
                                className: "z-[9999]",
                                children: "You're currently subscribed to this plan"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__separator_mjs_58b8de16__.Separator, {
                        className: "mt-[18px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: "min-h-0",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("ul", {
                    className: "space-y-2",
                    children: displayFeatures.map((feature, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("li", {
                            className: "flex items-start gap-2",
                            children: [
                                !feature.isHeader && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                                    children: feature.icon ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_ccd04ade__.SIcon, {
                                        type: feature.icon,
                                        className: "w-4 h-4 mt-[1px] flex-shrink-0"
                                    }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                                        className: "w-5 h-5 flex-shrink-0",
                                        style: {
                                            color: accentColor
                                        },
                                        fill: "currentColor",
                                        viewBox: "0 0 20 20",
                                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                            clipRule: "evenodd"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                    className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("text-sm", feature.isHeader ? "text-secondary-foreground" : "text-foreground"),
                                    children: feature.label
                                })
                            ]
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.Dialog, {
                open: showDowngradeDialog,
                onOpenChange: setShowDowngradeDialog,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogContent, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogHeader, {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogTitle, {
                                    children: "Confirm Downgrade"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogDescription, {
                                    children: [
                                        "Are you sure you want to downgrade to the ",
                                        plan.title,
                                        " plan? Your current subscription will be cancelled and you'll lose access to the following features",
                                        " ",
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            className: "underline",
                                            children: "at the end of your billing period"
                                        }),
                                        ". You can resubscribe at any time."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                            className: "my-4",
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("ul", {
                                className: "grid grid-cols-1 sm:grid-cols-2 gap-2",
                                children: getLostFeatures().map((feature, index)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("li", {
                                        className: "flex items-start gap-2 text-sm text-muted-foreground",
                                        children: [
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("svg", {
                                                className: "w-5 h-5 flex-shrink-0 text-destructive",
                                                fill: "currentColor",
                                                viewBox: "0 0 20 20",
                                                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                                                    clipRule: "evenodd"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                                children: feature.label
                                            })
                                        ]
                                    }, index))
                            })
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogFooter, {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                                    variant: "ghost",
                                    onClick: ()=>setShowDowngradeDialog(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                                    variant: "destructive",
                                    onClick: ()=>{
                                        onSelect?.(plan.id, plan.price.ids, "downgrade");
                                        setShowDowngradeDialog(false);
                                    },
                                    children: "Schedule Downgrade"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.Dialog, {
                open: showLegacyDialog,
                onOpenChange: setShowLegacyDialog,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogContent, {
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogHeader, {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogTitle, {
                                    children: "Switch from Legacy Plan"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogDescription, {
                                    children: [
                                        "You are currently on a legacy plan that is no longer available. Once you switch to the",
                                        " ",
                                        plan.title,
                                        " plan, you will",
                                        " ",
                                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                                            className: "underline text-amber-500",
                                            children: "not be able to switch back"
                                        }),
                                        " to your legacy plan. You will be charged for any current usage on your legacy plan immediately."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__dialog_mjs_15b9769c__.DialogFooter, {
                            children: [
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                                    variant: "ghost",
                                    onClick: ()=>setShowLegacyDialog(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
                                    variant: "default",
                                    onClick: ()=>{
                                        onSelect?.(plan.id, plan.price.ids, "upgrade");
                                        setShowLegacyDialog(false);
                                    },
                                    children: "Confirm Switch"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const PricingGrid = ({ pricing, actions, state, options })=>{
    const { mergeFeatures = true, hideDowngrades = false, filterByFeature } = options || {};
    const pricingContext = (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.usePricing)();
    const { plans, subscription } = pricing;
    const currentPriceIds = subscription?.priceIds || [];
    const isCancelled = subscription?.status === "cancelled";
    const disabled = state?.type === "disabled";
    const loadingPriceIds = void 0 !== pricingContext.loadingPriceIds ? pricingContext.loadingPriceIds : state?.type === "loading" ? state.priceIds : null;
    const onPlanChange = pricingContext.onPlanChange || actions?.onPlanChange;
    const onManage = pricingContext.onManage || actions?.onManage;
    const nonLegacyPlans = plans.filter((p)=>"legacy" !== p.id);
    let visiblePlans = nonLegacyPlans.filter((p)=>"visible" === p.status);
    if (hideDowngrades && currentPriceIds.length > 0) {
        const currentPlanIndex = (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.findCurrentPlanIndex)(visiblePlans, currentPriceIds);
        if (-1 !== currentPlanIndex) visiblePlans = visiblePlans.slice(currentPlanIndex);
    }
    const isLegacySubscription = pricingContext.currentPlan?.id === "legacy";
    const isCustomSubscription = pricingContext.currentPlan?.id === "enterprise";
    const gridCount = visiblePlans.length;
    const config = {
        base: 1,
        lg: 4
    };
    const gridClasses = "grid-cols-1 lg:grid-cols-4";
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)("grid w-full grid-rows-[auto_auto_auto_auto_1fr]", gridClasses),
        children: visiblePlans.map((plan, index)=>{
            const baseClasses = (0, __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__.getItemClasses)(index, config.base, "", gridCount);
            const lgClasses = (0, __WEBPACK_EXTERNAL_MODULE__utils_mjs_25ece7d1__.getItemClasses)(index, config.lg, "lg:", gridCount);
            const cornerClasses = (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)(baseClasses.corners, lgClasses.corners);
            const borderClasses = (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)(baseClasses.borders, lgClasses.borders);
            const isEnterprisePlan = "enterprise" === plan.id || !plan.id && ("premium" === plan.variant || "Enterprise" === plan.title);
            const isCustomPlanCard = isCustomSubscription && isEnterprisePlan;
            const shouldDisable = isCustomSubscription && !isEnterprisePlan;
            const planHasFeature = filterByFeature ? plan.features.find((f)=>f.key === filterByFeature)?.visible === true : true;
            const shouldDisableForFeature = filterByFeature && !planHasFeature;
            const allowPartialForCurrentPlan = isLegacySubscription;
            return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(PricingCard, {
                plan: plan,
                planIndex: index,
                allPlans: visiblePlans,
                isCurrentPlan: isCustomPlanCard || (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.matchesPriceIds)(plan.price.ids, currentPriceIds, allowPartialForCurrentPlan),
                onSelect: onPlanChange,
                onManageSubscription: onManage,
                disabled: disabled || shouldDisable || shouldDisableForFeature,
                isLoading: (0, __WEBPACK_EXTERNAL_MODULE__pricing_context_mjs_431e6334__.matchesPriceIds)(plan.price.ids, loadingPriceIds || [], false),
                mergeFeatures: mergeFeatures,
                cornerClasses: `${cornerClasses} ${borderClasses}`,
                currentPriceIds: currentPriceIds,
                isCancelled: isCancelled,
                isCustomPlan: isCustomPlanCard,
                isLegacyPlan: isLegacySubscription
            }, plan.id || plan.price.ids?.[0] || `plan-${index}`);
        })
    });
};
export { PricingCard, PricingGrid };
